import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  alternativeGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  attachmentList: {
    maxHeight: 400,
    overflowY: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1),
  },
  attachmentItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
  },
  fileIcon: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  fileName: {
    wordBreak: 'break-all',
  },
  listItem: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
  },
  removeButton: {
    flexShrink: 0,
  },
  addButton: {
    marginTop: theme.spacing(1),
  },
  emptyAttachments: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },

  attachmentButton: {
    padding: theme.spacing(2),
  },
  inputFile: {
    display: 'none',
  },
  uploadProgress: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.divider}`,
  },
  uploadProgressText: {
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
  },
}))

export default useStyles
